module.exports = __webpack_public_path__ + "static/Cait-9c6ed78695c62ec7648fc6aae374d520.gif";